var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TwitterItem"},[_c('div',{staticClass:"my-3"},[_c('p',[_vm._v(_vm._s(_vm.text))]),_c('p',[_c('small',[_vm._v(_vm._s(_vm.getFormatedDate(_vm.created_at))+" - "+_vm._s(_vm.getFormatedTime(_vm.created_at))+" Uhr")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }